const config = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:3001",
  endpoints: {
    // Auth
    auth: {
      adminLogin: "/auth/login",
      logout: "/auth/logout",
      refresh: "/auth/refresh",
      me: "/users/me",
    },
    // Admin - Users
    admin: {
      users: {
        list: "/admin/users",
        detail: (id: number) => `/admin/users/${id}`,
        create: "/admin/users",
        update: (id: number) => `/admin/users/${id}`,
        delete: (id: number) => `/admin/users/${id}`,
        updateStatus: (id: number) => `/admin/users/${id}/status`,
        resetPassword: (id: number) => `/admin/users/${id}/password`,
        export: "/admin/users/export",
      },
      payments: {
        list: "/admin/payments",
        detail: (id: number) => `/admin/payments/${id}`,
        export: "/admin/payments/export",
      },
      riskAssessments: {
        list: "/admin/risk-assessments",
        detail: (id: number) => `/admin/risk-assessments/${id}`,
        export: "/admin/risk-assessments/risk-assessments/export",
        exportSingle: (id: number) => `/risk-assessments/${id}/export`, // user API 사용
      },
      artifacts: {
        list: "/admin/artifacts",
        detail: (kind: "artifact" | "file", id: number) =>
          `/admin/artifacts/${kind}/${id}`,
      },
      riskAssessmentSurveys: {
        list: "/admin/risk-assessment-surveys",
      },
      susSurveys: {
        list: "/admin/sus-surveys",
      },
      board: {
        posts: "/admin/board/posts",
        postById: (id: number) => `/admin/board/posts/${id}`,
        replies: "/admin/board/replies",
        export: "/admin/board/posts/export",
        stats: "/admin/board/stats/overview",
      },
      blogFeed: {
        generate: "/admin/blog-feed/generate",
        run: (runId: string) =>
          `/admin/blog-feed/runs/${encodeURIComponent(runId)}`,
        stream: (runId: string) =>
          `/admin/blog-feed/runs/${encodeURIComponent(runId)}/stream`,
      },
    },
    // Board API (일반 사용자용)
    board: {
      categories: "/board/categories",
      posts: "/board/posts",
      postById: (id: number) => `/board/posts/${id}`,
      replies: "/board/replies",
    },
    files: {
      content: (id: number) => `/files/${id}/content`,
    },
  },
};

export default config;
